import React, { useState, useEffect } from "react";
import { IoFilter } from "react-icons/io5";
import { CgExport } from "react-icons/cg";
import ExpandedRow from "./ExpandedRow";
import * as XLSX from "xlsx";
import "./EncomendasTransformer.css";

const EncomendasTransformer = () => {
  const [filters, setFilters] = useState({
    dataRecebida: "",
    estado: "",
    processoAtual: "",
    produtoFinal: "",
  });
  const [showFilters, setShowFilters] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  const [orders, setOrders] = useState([]); // Estado para armazenar as encomendas
  const transformerId = localStorage.id; // ID do transformador obtido do localStorage

  // Função para buscar as encomendas do transformador
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch(`/webland-api/transformador/${transformerId}`);
        if (!response.ok) {
          throw new Error("Erro ao buscar encomendas");
        }
        const data = await response.json();
        setOrders(data); // Armazena as encomendas no estado
      } catch (error) {
        console.error("Erro ao buscar encomendas:", error);
      }
    };

    fetchOrders();
  }, [transformerId]);

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Encomendas");
    XLSX.writeFile(workbook, "encomendas.xlsx");
  };

  // Filtra os dados com base nos filtros aplicados
  const filteredData = orders.filter((item) => {
    return (
      (filters.dataRecebida === "" || item.receivedDate.includes(filters.dataRecebida)) &&
      (filters.estado === "" || item.status === filters.estado) &&
      (filters.processoAtual === "" || item.currentProcess === filters.processoAtual) &&
      (filters.produtoFinal === "" || item.finalProduct === filters.produtoFinal)
    );
  });

  return (
    <div className="tables-container-wrapper2">
      <div className="tables-container2">
        <div className="card-table22">
          <div className="card-table2-header2">
            <div className="card-table2-title2">Todas as Encomendas</div>
            <button className="filter-icon1" style={{ marginRight: "-60%" }} onClick={toggleFilters}>
              <IoFilter /> Filtros
            </button>
            <button className="filter-icon" onClick={exportToExcel}>
              <CgExport /> Exportar
            </button>
          </div>
          {showFilters && (
            <div className="filters">
              <input
                type="date"
                name="dataRecebida"
                value={filters.dataRecebida}
                onChange={handleFilterChange}
              />
              <select name="estado" value={filters.estado} onChange={handleFilterChange}>
                <option value="">Todos os estados</option>
                <option value="Em espera">Em espera</option>
                <option value="Em processamento">Em processamento</option>
                <option value="Concluído">Concluído</option>
              </select>
              <select name="processoAtual" value={filters.processoAtual} onChange={handleFilterChange}>
                <option value="">Todos os processos</option>
                <option value="Secagem">Secagem</option>
                <option value="Descasque">Descasque</option>
                <option value="Limpeza">Limpeza</option>
              </select>
              <select name="produtoFinal" value={filters.produtoFinal} onChange={handleFilterChange}>
                <option value="">Todos os produtos</option>
                <option value="Mel">Mel</option>
                <option value="Cera">Cera</option>
                <option value="Própolis">Própolis</option>
              </select>
            </div>
          )}
          <div className="card-table2-body">
            <table>
              <thead>
                <tr>
                  <th>Encomenda</th>
                  <th>Data Prevista Entrega</th>
                  <th>Data que Recebeu</th>
                  <th>Data Provisória de Conclusão</th>
                  <th>Estado</th>
                  <th>Processo Atual</th>
                  <th>Produto Final</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((order, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td>{order._id}</td>
                      <td>{order.expectedDeliveryDate || "N/A"}</td>
                      <td>{order.receivedDate || "N/A"}</td>
                      <td>{order.provisionalCompletionDate || "N/A"}</td>
                      <td>{order.status}</td>
                      <td>{order.currentProcess || "N/A"}</td>
                      <td>{order.finalProduct || "N/A"}</td>
                      <td>
                        <button className="button_more" onClick={() => toggleRow(index)}>
                          {expandedRow === index ? "Fechar" : "Ver mais"}
                        </button>
                      </td>
                    </tr>
                    {expandedRow === index && (
                      <tr className="expanded-row">
                        <td colSpan="8">
                          <ExpandedRow order={order} />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            {filteredData.length === 0 && <p>Nenhuma encomenda encontrada.</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EncomendasTransformer;